import 'core-js/actual';

import { initialPostman, preloader } from '@beeline/lk-utils';

import { createRoot } from 'react-dom/client';

import App from './App';

import { preloads } from ':constants';

import './sentry';

import ':styles/reset.scss';
import ':styles/global.scss';

import '@beeline/design-tokens/css/tokens/globals/index.css';
import '@beeline/design-tokens/css/font-face.css';
import '@beeline/design-tokens/css/iconfont/iconfont.css';

import '@beeline/design-tokens/css/tokens/themes/light.css';
import '@beeline/design-tokens/css/tokens/themes/dark.css';

import '@beeline/design-system-react/extracted-styles/esm/index.css';
import '@beeline/lk-utils/dist/style.css';
import '@beeline/lk-ui/core/style.css';

initialPostman('lke');

preloads.forEach(url => {
  preloader(url);
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);
root.render(<App />);

window.__LKEResourceLoaded(true);
